export const CREATORS = ['MHR_Qoo'] as const
export type CREATOR = (typeof CREATORS)[number]

export const creatorMapTargetId: Record<CREATOR, string> = {
  MHR_Qoo: 'monsterHunterWilds1',
}

export const mapCreatorInfo: Record<
  CREATOR,
  {
    profileCardImageURL: string
    creatorImageURL: string
  }
> = {
  MHR_Qoo: {
    profileCardImageURL: `/static/images/profiles/${creatorMapTargetId['MHR_Qoo']}/0.jpg`,
    creatorImageURL: '',
  },
}

export const weaponImages = Array(14)
  .fill(0)
  .map((_, i) => `/static/images/weapons/monsterHunterWilds1/${i}.png`)

export const weaponNames = [
  '大剣',
  '太刀',
  '片手剣',
  '双剣',
  'ハンマー',
  '狩猟笛',
  'ランス',
  'ガンランス',
  'スラッシュアックス',
  'チャージアックス',
  '操虫棍',
  'ライトボウガン',
  'ヘビィボウガン',
  '弓',
]

export const weaponGroups = {
  weapons: {
    images: weaponImages,
    names: weaponNames,
    startIndex: 0,
  },
}

export const ALL_WEAPON_IMAGES = weaponImages

export const creatorMapWeapons: Record<CREATOR, string[]> = {
  MHR_Qoo: ALL_WEAPON_IMAGES,
}
